//
//
//
//

export default {
    name: 'loading',
    props:{
        loadingWord:{
            type:String
        }
    } ,
    data () {
        return {
        };
    }
};



// WEBPACK FOOTER //
// ./src/components/common/scroll/base/Loading.vue